// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__WMgZ4","header":"PatientQuestionnaire_header__3K7V_","info":"PatientQuestionnaire_info__3bNqc"};